import React, { ReactElement } from 'react';
import Form from '@lib/wrappers/Form';
import GroupByTag from './GroupByTag';
import SegmentBy from './SegmentBy';
import ShowBy from './ShowBy';
import { FilterContainer } from './styles';

function UpcomingDueDateReport(props: {
    selectedReport: string;
    WorkGroupDropDown: ReactElement;
    RenderByWorkGroup: ReactElement;
    segmentBy: string;
    setSegmentBy: Function;
    isDrillDownActive: boolean;
    isTagFilterApplied: boolean;
    setIsTagFilterApplied: Function;
    showBy: string;
    setShowBy: Function;
}) {
    const {
        selectedReport,
        WorkGroupDropDown,
        RenderByWorkGroup,
        segmentBy,
        setSegmentBy,
        isDrillDownActive,
        isTagFilterApplied,
        setIsTagFilterApplied,
        showBy,
        setShowBy,
    } = props;
    return (
        <>
            <Form formName={'reportFilter'}>
                <FilterContainer className="filter-container">
                    <GroupByTag
                        isTagFilterApplied={isTagFilterApplied}
                        setIsTagFilterApplied={setIsTagFilterApplied}
                        isDrillDownActive={isDrillDownActive}
                    />
                    <ShowBy
                        showBy={showBy}
                        setShowBy={setShowBy}
                        isDrillDownActive={isDrillDownActive}
                        isTagFilterApplied={isTagFilterApplied}
                    />
                    <SegmentBy
                        selectedReport={selectedReport}
                        segmentBy={segmentBy}
                        setSegmentBy={setSegmentBy}
                        isDrillDownActive={isDrillDownActive}
                        isTagFilterApplied={isTagFilterApplied}
                    />
                    <div className="--select-report-container">{WorkGroupDropDown}</div>
                </FilterContainer>
                {RenderByWorkGroup}
            </Form>
        </>
    );
}

export default UpcomingDueDateReport;
